/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { onboardingCompleteStepPost$Json } from '../fn/onboarding/onboarding-complete-step-post-json';
import { OnboardingCompleteStepPost$Json$Params } from '../fn/onboarding/onboarding-complete-step-post-json';
import { onboardingCompleteStepPost$Plain } from '../fn/onboarding/onboarding-complete-step-post-plain';
import { OnboardingCompleteStepPost$Plain$Params } from '../fn/onboarding/onboarding-complete-step-post-plain';
import { OnboardingStateDto } from '../models/onboarding-state-dto';
import { onboardingStatesGet$Json } from '../fn/onboarding/onboarding-states-get-json';
import { OnboardingStatesGet$Json$Params } from '../fn/onboarding/onboarding-states-get-json';
import { onboardingStatesGet$Plain } from '../fn/onboarding/onboarding-states-get-plain';
import { OnboardingStatesGet$Plain$Params } from '../fn/onboarding/onboarding-states-get-plain';

@Injectable({ providedIn: 'root' })
export class OnboardingApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `onboardingCompleteStepPost()` */
  static readonly OnboardingCompleteStepPostPath = '/onboarding/complete-step';

  /**
   * Complete onboarding step.
   *
   * Marks a given onboarding step as completed and stores optional metadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `onboardingCompleteStepPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  onboardingCompleteStepPost$Plain$Response(params?: OnboardingCompleteStepPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OnboardingStateDto>> {
    const obs = onboardingCompleteStepPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete onboarding step.
   *
   * Marks a given onboarding step as completed and stores optional metadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `onboardingCompleteStepPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  onboardingCompleteStepPost$Plain(params?: OnboardingCompleteStepPost$Plain$Params, context?: HttpContext): Observable<OnboardingStateDto> {
    const resp = this.onboardingCompleteStepPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OnboardingStateDto>): OnboardingStateDto => r.body)
    );
  }

  /**
   * Complete onboarding step.
   *
   * Marks a given onboarding step as completed and stores optional metadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `onboardingCompleteStepPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  onboardingCompleteStepPost$Json$Response(params?: OnboardingCompleteStepPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<OnboardingStateDto>> {
    const obs = onboardingCompleteStepPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Complete onboarding step.
   *
   * Marks a given onboarding step as completed and stores optional metadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `onboardingCompleteStepPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  onboardingCompleteStepPost$Json(params?: OnboardingCompleteStepPost$Json$Params, context?: HttpContext): Observable<OnboardingStateDto> {
    const resp = this.onboardingCompleteStepPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<OnboardingStateDto>): OnboardingStateDto => r.body)
    );
  }

  /** Path part for operation `onboardingStatesGet()` */
  static readonly OnboardingStatesGetPath = '/onboarding/states';

  /**
   * Get onboarding states.
   *
   * Returns onboarding states for a user in an organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `onboardingStatesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  onboardingStatesGet$Plain$Response(params?: OnboardingStatesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingStateDto>>> {
    const obs = onboardingStatesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get onboarding states.
   *
   * Returns onboarding states for a user in an organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `onboardingStatesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  onboardingStatesGet$Plain(params?: OnboardingStatesGet$Plain$Params, context?: HttpContext): Observable<Array<OnboardingStateDto>> {
    const resp = this.onboardingStatesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OnboardingStateDto>>): Array<OnboardingStateDto> => r.body)
    );
  }

  /**
   * Get onboarding states.
   *
   * Returns onboarding states for a user in an organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `onboardingStatesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  onboardingStatesGet$Json$Response(params?: OnboardingStatesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OnboardingStateDto>>> {
    const obs = onboardingStatesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get onboarding states.
   *
   * Returns onboarding states for a user in an organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `onboardingStatesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  onboardingStatesGet$Json(params?: OnboardingStatesGet$Json$Params, context?: HttpContext): Observable<Array<OnboardingStateDto>> {
    const resp = this.onboardingStatesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<OnboardingStateDto>>): Array<OnboardingStateDto> => r.body)
    );
  }

}
